// src/modules/helpdesk/novoChamado.js — Fase 1c · FAB + modal Novo Chamado (abrirModalChamado) fiel ao monolito.
import { sb } from '../../api/supabaseClient.js';
import { guardTrial } from '../../lib/trialGate.js';
import { tenant } from '../../context/tenantContext.js';
import { esc } from '../../lib/dom.js';
import { showToast } from '../../lib/toast.js';
import { openModal, closeModal } from '../../components/modal.js';

const CHAMADO_TIPO_LABEL = { bug: '🐛 Bug / Erro', melhoria: '✨ Melhoria', duvida: '❓ Dúvida', sugestao: '💡 Sugestão' };
let _chamadoScreenshot = null;

async function _ensureHtml2canvas() {
  if (window.html2canvas) return window.html2canvas;
  const { default: h2c } = await import('html2canvas');
  window.html2canvas = h2c;
  return h2c;
}
async function _capturarTelaSuporte() {
  let html2canvas;
  try { html2canvas = await _ensureHtml2canvas(); } catch (e) { return null; }
  try {
    const isMobile = window.matchMedia('(max-width:768px)').matches;
    const canvas = await html2canvas(document.body, {
      backgroundColor: getComputedStyle(document.body).backgroundColor || '#0E0E14',
      scale: 1, logging: false, useCORS: true,
      width: isMobile ? document.documentElement.clientWidth : undefined,
      height: isMobile ? document.documentElement.clientHeight : undefined,
      windowWidth: isMobile ? document.documentElement.clientWidth : undefined,
      windowHeight: isMobile ? document.documentElement.clientHeight : undefined,
      ignoreElements: (el) => el.classList?.contains('desk-fab') || el.id === 'chamado-screenshot-preview',
    });
    const MAX_W = isMobile ? 900 : 1200;
    let outCanvas = canvas;
    if (canvas.width > MAX_W) {
      const ratio = MAX_W / canvas.width;
      outCanvas = document.createElement('canvas');
      outCanvas.width = MAX_W; outCanvas.height = Math.round(canvas.height * ratio);
      outCanvas.getContext('2d').drawImage(canvas, 0, 0, outCanvas.width, outCanvas.height);
    }
    return outCanvas.toDataURL('image/webp', 0.7);
  } catch (err) { return null; }
}
function _dataURLtoBlob(dataURL) {
  const [meta, b64] = dataURL.split(',');
  const mime = (meta.match(/data:([^;]+)/) || [, 'image/webp'])[1];
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type: mime });
}
async function _renovarScreenshotChamado() {
  const box = document.getElementById('chamado-screenshot-preview');
  if (box) box.innerHTML = '<div style="padding:24px;text-align:center;color:var(--text3);font-size:12px">📸 Capturando tela…</div>';
  _chamadoScreenshot = await _capturarTelaSuporte();
  _renderScreenshotPreview();
}
function _renderScreenshotPreview() {
  const box = document.getElementById('chamado-screenshot-preview');
  if (!box) return;
  if (_chamadoScreenshot) {
    box.innerHTML = `<div style="position:relative;display:inline-block;max-width:100%">
      <img src="${_chamadoScreenshot}" alt="Print da tela" style="max-width:100%;max-height:160px;border-radius:6px;border:1px solid var(--border);display:block;cursor:zoom-in" onclick="window.open(this.src,'_blank')">
      <button onclick="_renovarScreenshotChamado()" type="button" style="position:absolute;top:6px;right:6px;background:rgba(0,0,0,.7);color:#fff;border:0;border-radius:4px;padding:3px 8px;font-size:10px;cursor:pointer">📸 Nova captura</button>
      <button onclick="_chamadoRemoverScreenshot()" type="button" style="position:absolute;top:6px;right:108px;background:rgba(0,0,0,.7);color:#fff;border:0;border-radius:4px;padding:3px 8px;font-size:10px;cursor:pointer">✕ Remover</button></div>`;
  } else {
    box.innerHTML = `<button onclick="_renovarScreenshotChamado()" type="button" class="btn btn-secondary" style="font-size:13px;padding:6px 12px">📸 Anexar print da tela</button>`;
  }
}
function _chamadoRemoverScreenshot() { _chamadoScreenshot = null; _renderScreenshotPreview(); }
async function _uploadScreenshotChamado(chamadoId) {
  if (!_chamadoScreenshot || !tenant.empresaId) return null;
  try {
    const blob = _dataURLtoBlob(_chamadoScreenshot);
    const path = `${tenant.empresaId}/${chamadoId}/${Date.now()}.webp`;
    const { error } = await sb.storage.from('suporte-screenshots').upload(path, blob, { contentType: 'image/webp', upsert: false });
    if (error) return null;
    const { data } = sb.storage.from('suporte-screenshots').getPublicUrl(path);
    return data?.publicUrl || null;
  } catch (err) { return null; }
}

async function abrirModalChamado(preShot) {
  if (guardTrial()) return;

  const ctx = window._subBarCtx || {};
  const ctxScreenId = ctx.id || null;
  const ctxScreenLabel = ctx.pagina || null;
  _chamadoScreenshot = (preShot && typeof preShot === 'string') ? preShot : null;

  let body = '';
  if (ctxScreenId) {
    body += '<div style="background:var(--accent-bg);border:1px solid color-mix(in oklab, var(--sc-info) 20%, transparent);border-radius:8px;padding:10px 12px;margin-bottom:16px">'
      + '<div style="font-size:10px;font-weight:700;color:var(--text3);letter-spacing:.6px;text-transform:uppercase;margin-bottom:6px">Onde aconteceu</div>'
      + '<div style="display:flex;flex-wrap:wrap;gap:8px"><div style="display:inline-flex;align-items:center;gap:6px;background:var(--card);border:1px solid var(--border);border-radius:6px;padding:4px 8px">'
      + '<span style="font-size:9px;color:var(--text3);font-weight:600;letter-spacing:.5px">Tela</span>'
      + '<span style="font-family:monospace;font-size:11px;font-weight:700;color:var(--sc-info)">' + esc(ctxScreenId) + '</span>'
      + (ctxScreenLabel ? '<span style="font-size:11px;color:var(--text2)">' + esc(ctxScreenLabel) + '</span>' : '')
      + '</div></div></div>';
  }
  body += '<div class="form-group"><label>Print da tela</label><div id="chamado-screenshot-preview" style="padding:8px;background:var(--card);border:1px dashed var(--border);border-radius:8px;text-align:center"><div style="padding:14px;text-align:center;color:var(--text3);font-size:12px">📸 Capturando tela…</div></div></div>';
  let tipoBtns = '';
  Object.keys(CHAMADO_TIPO_LABEL).forEach((k) => { tipoBtns += '<button onclick="selTipoChamado(\'' + k + '\')" id="tipo-btn-' + k + '" style="padding:8px;border-radius:8px;border:1px solid var(--border);background:var(--card);color:var(--text2);cursor:pointer;font-size:13px;transition:.15s">' + CHAMADO_TIPO_LABEL[k] + '</button>'; });
  body += '<div class="form-group"><label>Tipo *</label><div style="display:grid;grid-template-columns:1fr 1fr;gap:8px" id="chamado-tipo-btns">' + tipoBtns + '</div><input type="hidden" id="chamado-tipo" value="bug"></div>'
    + '<div class="form-group"><label>Prioridade</label><select id="chamado-prio" style="width:100%;padding:8px 10px;background:var(--card);border:1px solid var(--border);border-radius:8px;color:var(--text);font-size:13px"><option value="baixa">🟢 Baixa</option><option value="normal" selected>🔵 Normal</option><option value="alta">🟡 Alta</option><option value="urgente">🔴 Urgente</option></select></div>'
    + '<div class="form-group"><label>Assunto *</label><input type="text" id="chamado-assunto" placeholder="Descreva o problema em uma linha..." style="width:100%;padding:8px 10px;background:var(--card);border:1px solid var(--border);border-radius:8px;color:var(--text);font-size:13px"></div>'
    + '<div class="form-group"><label>Descrição detalhada</label><textarea id="chamado-desc" rows="4" placeholder="Passos para reproduzir, o que esperava vs o que aconteceu..." style="width:100%;padding:8px 10px;background:var(--card);border:1px solid var(--border);border-radius:8px;color:var(--text);font-size:13px;resize:vertical"></textarea></div>'
    + '<input type="hidden" id="chamado-ctx-screen-id" value="' + esc(ctxScreenId || '') + '"><input type="hidden" id="chamado-ctx-screen-name" value="' + esc(ctxScreenLabel || '') + '">';

  openModal({
    title: '🎫 Abrir Chamado de Suporte', size: 'large', bodyHTML: body,
    buttons: [{ label: 'Cancelar', action: 'cancel' }, { label: 'Enviar Chamado', kind: 'primary', action: () => _submitChamado() }],
  });
  setTimeout(() => selTipoChamado('bug'), 100);
  setTimeout(async () => { _chamadoScreenshot = await _capturarTelaSuporte(); _renderScreenshotPreview(); }, 250);
}

async function _submitChamado() {
  const tipo = document.getElementById('chamado-tipo')?.value;
  const prio = document.getElementById('chamado-prio')?.value;
  const assunto = document.getElementById('chamado-assunto')?.value?.trim();
  const desc = document.getElementById('chamado-desc')?.value?.trim();
  if (!assunto) { showToast('Informe o assunto do chamado.', 'error'); return false; }
  const ctxScreenId = document.getElementById('chamado-ctx-screen-id')?.value || null;
  const ctxScreenName = document.getElementById('chamado-ctx-screen-name')?.value || null;
  const { data: chamado, error } = await sb.from('suporte_chamados').insert({
    empresa_id: tenant.empresaId, usuario_id: tenant.user?.id, codigo_tela: ctxScreenId || null, nome_tela: ctxScreenName || null,
    codigo_modal: null, nome_modal: null, tipo, prioridade: prio, assunto, descricao: desc,
  }).select('id').single();
  if (error) { showToast('Erro ao abrir chamado: ' + error.message, 'error'); return false; }
  if (_chamadoScreenshot && chamado?.id) {
    const url = await _uploadScreenshotChamado(chamado.id);
    if (url) await sb.from('suporte_chamados').update({ screenshot_url: url }).eq('id', chamado.id);
  }
  _chamadoScreenshot = null;
  showToast('Chamado aberto! Acompanhe em Meus Chamados.');
  if (window.renderMeusChamados && (window.location.hash || '').indexOf('meus_chamados') >= 0) window.renderMeusChamados();
  return true;
}
function selTipoChamado(tipo) {
  const el = document.getElementById('chamado-tipo'); if (el) el.value = tipo;
  Object.keys(CHAMADO_TIPO_LABEL).forEach((k) => {
    const b = document.getElementById('tipo-btn-' + k);
    if (b) { b.style.background = k === tipo ? 'var(--accent-bg)' : 'var(--card)'; b.style.borderColor = k === tipo ? 'var(--sc-info)' : 'var(--border)'; b.style.color = k === tipo ? 'var(--sc-info)' : 'var(--text2)'; }
  });
}

// FAB flutuante — injeta no body uma vez (só logado, não super_admin)
export function mountChamadoFab() {
  if (document.querySelector('.desk-fab')) return;
  if (tenant.isSuperAdmin) return;
  const btn = document.createElement('button');
  btn.className = 'desk-fab';
  btn.title = 'Suporte / Chamados';
  btn.setAttribute('aria-label', 'Abrir chamado de suporte');
  // Icone diz o que o botao FAZ (abrir chamado). O logo da marca sugeria 'menu da Angular'.
  btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>';
  btn.onclick = () => abrirModalChamado();
  btn.style.display = 'flex';  // canonical .desk-fab é display:none até body.logged-in (não usado no Vite)
  document.body.appendChild(btn);
}

Object.assign(window, { abrirModalChamado, _submitChamado, selTipoChamado, _renovarScreenshotChamado, _chamadoRemoverScreenshot, _capturarTelaSuporte });
export { abrirModalChamado };
